export default "__VITE_ASSET__CnacPlDc__"